/* eslint no-tabs: "off", indent: "off", no-case-declarations: "off", no-lonely-if: "off" */

import React from "react";
import _ from "underscore";

import projectList from "config/projectList.js";

const initialState = {
	// User profile
	// authState: "",
	authToken: "",
	// Store username/email for user for when they recover their password
	//	This is okay because the Recover Password screen is only accessible after requesting a new one
	stashUsername: "",
	userEmail: "",
	userName: "",
	userPool: [""],
	userData: null, // Whole CognitoUser object. Only used directly for changing password
	api: {}, // API endpoints
	availableProjects: [""],
	currentProject: "",

	// Try not to use this. Do feature detection whenever possible
	browserType: "", // string: "blink", "chrome", "edge", "ie", "safari", "firefox", "opera", or undefined

	// UI
	changePasswordModalOpen: false,
	changePasswordSuccess: false,
	checkedForExistingUserOnLoad: false,
	codeDeliveryMessage: "",
	createNewPassword: false,
	forceChangePassword: false,
	forgotPassword: false,
	loggedIn: false,
	loginError: false,
	userJustLoggedIn: false,
	validationInProgress: false,

	// Spinner logic
	projectSpinner: false,
	currentNumberOfTrends: 0,
	targetNumberOfTrends: 0,

	// Controled inputs
	loginErrorText: "",
	loginInputEmail: "",
	loginInputChangePasswordNew: "",
	loginInputChangePasswordOld: "",
	loginInputPassword: "",
	loginInputVerificationCode: "",
	loginInputNewPassword: "",
};

const login = (state = initialState, action) => {
	switch (action.type) {
		case "attemptingLogIn":
			return Object.assign({}, state, {
				loginError: false,
				validationInProgress: true,
			});
		case "logInSuccess":
			const { user, lastProject } = action;
			const userPool =
				user.signInUserSession && user.signInUserSession.idToken.payload["cognito:groups"];
			const availableProjects = userPool.map((project) => {
				return { name: projectList[project], id: project };
			});
			return Object.assign({}, state, {
				authToken: user.pool && user.pool.clientId,
				checkedForExistingUserOnLoad: true,
				loggedIn: true,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				validationInProgress: false,
				userEmail: user.signInUserSession && user.signInUserSession.idToken.payload.email,
				userData: user,
				userName: user.username,
				userPool,
				currentProject: lastProject || userPool[0],
				availableProjects: _.filter(availableProjects, (proj) => {
					return proj.name;
				}),
			});
		case "logInError":
			console.log("logInError", action);
			const errorText =
				action.error.code === "UserNotFoundException" ? "User not found" : action.error.message;
			console.warn("log in error:", action.error.message);

			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: errorText,
				validationInProgress: false,
			});
		case "notLoggedIn":
			return Object.assign({}, state, {
				checkedForExistingUserOnLoad: true,
				loggedIn: false,
			});
		case "setAPI":
			return Object.assign({}, state, {
				api: action.api,
			});
		case "setProject":
			return Object.assign({}, state, {
				currentProject: action.project,
				projectSpinner: true,
				currentNumberOfTrends: 0,
			});
		case "setBrowserType":
			return Object.assign({}, state, {
				browserType: action.browser,
			});
		case "receiveTrends":
			return Object.assign({}, state, {
				targetNumberOfTrends: action.trends ? action.trends.length : 1,
			});
		case "receiveTimeseries":
			// console.log(
			// 	"currentNumberOfTrends",
			// 	state.currentNumberOfTrends + 1,
			// 	"of",
			// 	state.targetNumberOfTrends
			// );

			return Object.assign({}, state, {
				currentNumberOfTrends: state.currentNumberOfTrends + 1,
				projectSpinner: state.currentNumberOfTrends + 1 < state.targetNumberOfTrends,
			});
		case "createOriginalPasswordSuccess":
			const firstTimeUser = action.userData;
			return Object.assign({}, state, {
				authToken: firstTimeUser.pool && firstTimeUser.pool.clientId,
				forceChangePassword: false,
				loggedIn: true,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				validationInProgress: false,
				userEmail:
					firstTimeUser.signInUserSession && firstTimeUser.signInUserSession.idToken.payload.email,
				userData: firstTimeUser,
				userName: firstTimeUser.username,
				userPool:
					firstTimeUser.signInUserSession &&
					firstTimeUser.signInUserSession.idToken.payload["cognito:groups"],
			});
		case "createOriginalPasswordError":
			const firstTimeErrorText =
				action.error.code === "UserNotFoundException" ? "User not found" : action.error.message;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: firstTimeErrorText,
				validationInProgress: false,
			});
		case "signedOut":
			if (action.error) {
				console.error("signedOut error. login reducer", action.error);
			}
			return Object.assign({}, state, {
				loggedIn: false,
			});
		// User object is incomplete for these users.
		case "forcePasswordUpdate":
			return Object.assign({}, state, {
				checkedForExistingUserOnLoad: true,
				forceChangePassword: true,
				loginError: false,
				loginErrorText: "",
				loginInputChangePasswordOld: action.userJustLoggedIn ? state.loginInputPassword : "",
				loginInputEmail: "",
				loginInputPassword: "",
				userJustLoggedIn: action.userJustLoggedIn,
				validationInProgress: false,
				userName: action.username,
				userData: action.user,
			});

		case "recoverPasswordSuccess":
			return Object.assign({}, state, {
				createNewPassword: true,
				codeDeliveryMessage: `Your reset code was delivered to ${
					action.user.CodeDeliveryDetails.Destination
				}`,
				forgotPassword: false,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				stashUsername: action.username,
				validationInProgress: false,
			});
		case "recoverPasswordError":
			const recoverPasswordErrorText =
				action.error.code === "UserNotFoundException" ? "User not found" : action.error.message;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: recoverPasswordErrorText,
				validationInProgress: false,
			});
		case "resetPasswordSuccess":
			// User will be logged in at this point
			return Object.assign({}, state, {
				createNewPassword: false,
				codeDeliveryMessage: "",
				forgotPassword: false,
				loggedIn: true,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				loginInputVerificationCode: "",
				loginInputNewPassword: "",
				stashUsername: "",
				validationInProgress: false,
			});
		case "resetPasswordError":
			const resetPasswordErrorText =
				action.error.code === "UserNotFoundException"
					? "User not found"
					: action.error.message ? action.error.message : action.error;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: resetPasswordErrorText,
				validationInProgress: false,
			});

		case "changePasswordSuccess":
			// User will be logged in at this point
			return Object.assign({}, state, {
				changePasswordSuccess: true,
				loginError: false,
				loginErrorText: "",
				loginInputChangePasswordNew: "",
				loginInputChangePasswordOld: "",
				validationInProgress: false,
			});
		case "changePasswordError":
			const changePasswordErrorText =
				action.error.code === "UserNotFoundException"
					? "User not found"
					: action.error.message ? action.error.message : action.error;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: changePasswordErrorText,
				validationInProgress: false,
			});

		// ---- Login navigation ----
		case "openForgotPasswordView":
			return Object.assign({}, state, {
				createNewPassword: false,
				loggedIn: false,
				forgotPassword: true,
				loginError: false,
				loginErrorText: "",
			});
		case "backToLogin":
			return Object.assign({}, state, {
				createNewPassword: false,
				forgotPassword: false,
				loginError: false,
				loginErrorText: "",
				loginInputVerificationCode: "",
				loginInputNewPassword: "",
			});
		case "openChangePasswordModal":
			return Object.assign({}, state, {
				changePasswordModalOpen: true,
			});
		case "closeChangePasswordModal":
			return Object.assign({}, state, {
				changePasswordModalOpen: false,
				changePasswordSuccess: false,
				loginError: false,
				loginErrorText: "",
				loginInputChangePasswordNew: "",
				loginInputChangePasswordOld: "",
			});

		// Controlled Inputs
		case "updateLoginEmail":
			return Object.assign({}, state, {
				loginInputEmail: action.email,
			});
		case "updatePassword":
			return Object.assign({}, state, {
				loginInputPassword: action.password,
			});
		case "updateLoginVerificationCode":
			return Object.assign({}, state, {
				loginInputVerificationCode: action.code,
			});
		case "updateLoginNewPassword":
			return Object.assign({}, state, {
				loginInputNewPassword: action.password,
			});
		case "updateChangePasswordNew":
			return Object.assign({}, state, {
				loginInputChangePasswordNew: action.password,
			});
		case "updateChangePasswordOld":
			return Object.assign({}, state, {
				loginInputChangePasswordOld: action.password,
			});

		default:
			return state;
	}
};

export default login;
